import React from 'react';
import styles from './index.module.scss';
import { formatBoldText } from '../../../../utils/formatBoldText';

const ItemDescriptionBlockV1 = ({ block }) => {
  if (!block) {
    return null;
  }

  const descriptions = [];
  const specifications = [];

  if (Array.isArray(block.block_content)) {
    block.block_content.forEach((contentItem) => {
      if (!contentItem || !(contentItem.cotent_tag || contentItem.content_tag) || !contentItem.content_text) {
        return;
      }

      const tag = (contentItem.cotent_tag || contentItem.content_tag).toLowerCase();
      const text = contentItem.content_text.trim();

      if (tag === 'description') {
        descriptions.push(text);
      }

      if (tag === 'specifications') {
        const items = text
          .split(';')
          .map((item) => item.trim())
          .filter(Boolean);

        if (items.length > 0) {
          specifications.push(...items);
        }
      }
    });
  }

  return (
    <section className={styles.itemDescriptionBlockV1}>
      {block.block_title && <h3 className={styles.title}>{block.block_title}</h3>}

      {descriptions.length > 0 && (
        <div className={styles.section}>
          <h4 className={styles.sectionTitle}>Описание</h4>
          <div className={styles.descriptionList}>
            {descriptions.map((text, index) => {
              // Разбиваем текст по переносам строк для создания абзацев
              const paragraphs = text.split('\n').map((p) => p.trim()).filter(Boolean);
              
              return paragraphs.map((paragraph, paragraphIndex) => {
                // Применяем функцию formatBoldText для обработки маркеров =bold и bold=
                const formattedText = formatBoldText(paragraph);
                
                return (
                  <p key={`description-${index}-${paragraphIndex}`} className={styles.paragraph}>
                    {formattedText.map((part, partIndex) => (
                      <React.Fragment key={`part-${index}-${paragraphIndex}-${partIndex}`}>
                        {part}
                      </React.Fragment>
                    ))}
                  </p>
                );
              });
            })}
          </div>
        </div>
      )}

      {specifications.length > 0 && (
        <div className={styles.section}>
          <h4 className={styles.sectionTitle}>Характеристики</h4>
          <div className={`${styles.descriptionList} ${styles.specificationsList}`}>
            {specifications.map((text, index) => (
              <div
                key={`specification-${index}`}
                className={`${styles.specificationItem} ${
                  index % 2 === 0 ? styles.specificationEven : styles.specificationOdd
                } ${index === specifications.length - 1 ? styles.specificationLast : ''}`}>
                <span className={styles.specificationBullet} />
                <span className={styles.specificationText}>{text}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
};

export default ItemDescriptionBlockV1;
